<template>
  <v-container>
    <v-form ref="PlacementPaymentForm">
      <v-row>
        <v-col cols="12" sm="6">
          <SimpleDatePicker
            :label="`Received On`"
            :value="receivedAt"
            :isRequired="true"
            @selected-date-change="handleDateChange"
          ></SimpleDatePicker>
        </v-col>
        <v-col cols="12" sm="6">
          <FormattedNumberField
            label="Amount"
            :value="amount"
            :rules="[required('Amount'), greaterThanZero]"
            :validate-on-blur="true"
            prepend-inner-icon="attach_money"
            @valueChange="(newValue) => this.amount = newValue"
          ></FormattedNumberField>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-textarea
            label="Payment Notes"
            outlined
            v-model="paymentNotes"
          ></v-textarea>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import { mapFields } from '@/vueHelpers/vuex'
import { SimpleDatePicker } from '@/components/shared/datePickers'
import required from '@/lib/formValidations/required'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    SimpleDatePicker,
    FormattedNumberField
  },
  props: [
    'paymentInput'
  ],
  computed: {
    ...mapFields('directPlacementPayment', [
      'id',
      'receivedAt',
      'amount',
      'paymentNotes'
    ])
  },
  methods: {
    handleDateChange (newValue) {
      this.receivedAt = newValue
    },
    required,
    greaterThanZero () {
      return this.amount > 0 ? true : 'Amount must be greater than $0'
    }
  }
}
</script>
